import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ScrollRendererPolyfill from './ScrollRendererPolyfill';
import { selectFeatureFlags } from '../../../selectors/ContextSelector';

const ScrollRenderer = ({ children, ...props }) => {
    const featureFlags = useSelector(selectFeatureFlags);

    return featureFlags.enableReactRenderingStrategy ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ScrollRendererPolyfill {...props}>{children}</ScrollRendererPolyfill>
    ) : (
        children
    );
};

ScrollRenderer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
ScrollRenderer.defaultProps = {};

export default ScrollRenderer;
